/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';


export const useTransactionLimitTracker = ({ eSpotName }: any) => {
  const variables = {
    eSpotName: eSpotName
  };
  const TRANSACTION_LIMIT_TRACKER_GQL = gql`
    query EMarketingSpotByName($eSpotName: String!) {
      eMarketingSpotByName(eSpotName: $eSpotName) {
        MarketingSpotData {
          defaultContentDisplaySequence {
            resultId
            resultFormat
            displaySequence
          }
          baseMarketingSpotActivityData {
            marketingContentDescription {
              marketingText
              language
            }
          }
        }
      }
    }
`;
  const { data, loading, error } = useQuery(TRANSACTION_LIMIT_TRACKER_GQL, {
    variables,
    context:{
      clientName:"espot"
    }
  });
  return { data, loading, error };
};